<script>
  import CBrow        from "./CBrow.svelte";
  import * as animateScroll from "svelte-scrollto";
  export let scrollY;
  let outerWidth;
  let firstExpand = false;

  let navExpand = false;

  function navTrig() {
    navExpand = !navExpand;
    firstExpand = true;
  }

  function scrollToElement(element, offset, top) {
    if (top) {
      animateScroll.scrollToTop();
    } else {
      animateScroll.scrollTo({element: element, offset: offset});
    }
    navExpand = false;
  }
</script>

<!-- <svelte:head>
   {#if navExpand}
      <style>
         body {
            position: fixed;
            overflow-y:scroll;
         }
      </style>
   {/if}
</svelte:head> -->

<svelte:window bind:outerWidth/>

<style>
  .topbar {
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
    font-stretch: extra-expanded;
    font-size: 20px;
  }

  .toplogo {
    margin-top: 25px;
  }

  .toplogo img {
    max-width: 135px;
    height: auto;
  }

  .hidden {
    -moz-animation: cssAnimation 0s ease-in 0.4s forwards;
    -webkit-animation: cssAnimation 0s ease-in 0.4s forwards;
    -o-animation: cssAnimation 0s ease-in 0.4s forwards;
    animation: cssAnimation 0s ease-in 0.4s forwards;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  .hide {
    margin-top: 0;
    display: none;
  }

  @keyframes cssAnimation {
    to {
      width:0;
      height:0;
      overflow:hidden;
      display: none;
      margin-top: 0;
    }
  }
  @-webkit-keyframes cssAnimation {
    to {
      width:0;
      height:0;
      visibility:hidden;
      display:none;
      margin-top: 0;
    }
  }

  a {
    cursor: pointer;
  }

  a:hover {
    color: var(--palette-pop) !important;
  }

  .main_list {
    height: 65px;
    float: right;
    position: relative;
    top: 5px;
  }
  .main_list ul {
    width: 100%;
    height: 65px;
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .main_list ul li {
    width: auto;
    height: 65px;
    padding: 0;
    padding-top: 0px;
  }

  .main_list ul li a {
    text-decoration: none;
    color: #fff;
    line-height: 65px;
    font-size: 1.2rem;
    padding-left: 2rem;
  }

  .navTrigger {
    display: none;
  }

  @media screen and (max-width:991px) {
    .main_list ul li a {
        font-size: 1rem;
        padding-left: 0.7rem;
    }
  }

  @media screen and (max-width:408px) {
    .handwriting.small {
        font-size: 25px;
    }
    .main_list ul li a {
        font-size: 1.2rem;
    }
  }

  @media screen and (max-width:767px) {
    .navTrigger {
        display: block;
    }

    .main_list {
        width: 100%;
        height: 0;
        overflow: hidden;
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease;
        top: 50px;
    }

    .show_list {
        height: 100%;
    }

    .main_list ul {
        flex-direction: column;
        width: 100%;
        height: 100vh;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: var(--palette-grad2);
        /*same background color of navbar*/
        background-position: center top;
    }

    .main_list ul li {
        width: 100%;
        text-align: right;
    }

    .main_list ul li a {
        text-align: center;
        width: 100%;
        font-size: 1.3rem;
        padding-right: 0px;
        padding-left: 0;
    }
  }

  @media screen and (max-width:576px) {
    :global(.left.compressed) {
      padding-left: 15px !important;
    }
  }

  .navTrigger {
      cursor: pointer;
      width: 30px;
      height: 25px;
      margin: auto;
      position: relative;
      right: 30px;
      top: 25px;
      bottom: 0;
      float: right;
  }

  .navTrigger i {
      background-color: #fff;
      border-radius: 2px;
      content: '';
      display: block;
      width: 100%;
      height: 4px;
  }

  .navTrigger i:nth-child(1) {
      -webkit-animation: outT 0.4s backwards;
      animation: outT 0.4s backwards;
      -webkit-animation-direction: reverse;
      animation-direction: reverse;
  }

  .navTrigger i:nth-child(2) {
      margin: 5px 0;
      -webkit-animation: outM 0.4s backwards;
      animation: outM 0.4s backwards;
      -webkit-animation-direction: reverse;
      animation-direction: reverse;
  }

  .navTrigger i:nth-child(3) {
      -webkit-animation: outBtm 0.4s backwards;
      animation: outBtm 0.4s backwards;
      -webkit-animation-direction: reverse;
      animation-direction: reverse;
  }

  .navTrigger.active i:nth-child(1) {
      -webkit-animation: inT 0.4s forwards;
      animation: inT 0.4s forwards;
  }

  .navTrigger.active i:nth-child(2) {
      -webkit-animation: inM 0.4s forwards;
      animation: inM 0.4s forwards;
  }

  .navTrigger.active i:nth-child(3) {
      -webkit-animation: inBtm 0.4s forwards;
      animation: inBtm 0.4s forwards;
  }

  @-webkit-keyframes inM {
      50% {
          -webkit-transform: rotate(0deg);
      }
      100% {
          -webkit-transform: rotate(45deg);
      }
  }

  @keyframes inM {
      50% {
          transform: rotate(0deg);
      }
      100% {
          transform: rotate(45deg);
      }
  }

  @-webkit-keyframes outM {
      50% {
          -webkit-transform: rotate(0deg);
      }
      100% {
          -webkit-transform: rotate(45deg);
      }
  }

  @keyframes outM {
      50% {
          transform: rotate(0deg);
      }
      100% {
          transform: rotate(45deg);
      }
  }

  @-webkit-keyframes inT {
      0% {
          -webkit-transform: translateY(0px) rotate(0deg);
      }
      50% {
          -webkit-transform: translateY(9px) rotate(0deg);
      }
      100% {
          -webkit-transform: translateY(9px) rotate(135deg);
      }
  }

  @keyframes inT {
      0% {
          transform: translateY(0px) rotate(0deg);
      }
      50% {
          transform: translateY(9px) rotate(0deg);
      }
      100% {
          transform: translateY(9px) rotate(135deg);
      }
  }

  @-webkit-keyframes outT {
      0% {
          -webkit-transform: translateY(0px) rotate(0deg);
      }
      50% {
          -webkit-transform: translateY(9px) rotate(0deg);
      }
      100% {
          -webkit-transform: translateY(9px) rotate(135deg);
      }
  }

  @keyframes outT {
      0% {
          transform: translateY(0px) rotate(0deg);
      }
      50% {
          transform: translateY(9px) rotate(0deg);
      }
      100% {
          transform: translateY(9px) rotate(135deg);
      }
  }

  @-webkit-keyframes inBtm {
      0% {
          -webkit-transform: translateY(0px) rotate(0deg);
      }
      50% {
          -webkit-transform: translateY(-9px) rotate(0deg);
      }
      100% {
          -webkit-transform: translateY(-9px) rotate(135deg);
      }
  }

  @keyframes inBtm {
      0% {
          transform: translateY(0px) rotate(0deg);
      }
      50% {
          transform: translateY(-9px) rotate(0deg);
      }
      100% {
          transform: translateY(-9px) rotate(135deg);
      }
  }

  @-webkit-keyframes outBtm {
      0% {
          -webkit-transform: translateY(0px) rotate(0deg);
      }
      50% {
          -webkit-transform: translateY(-9px) rotate(0deg);
      }
      100% {
          -webkit-transform: translateY(-9px) rotate(135deg);
      }
  }

  @keyframes outBtm {
      0% {
          transform: translateY(0px) rotate(0deg);
      }
      50% {
          transform: translateY(-9px) rotate(0deg);
      }
      100% {
          transform: translateY(-9px) rotate(135deg);
      }
  }

  /* .floater {
      border: solid 1px black;
      background-color: white;
      border-radius: 50%;
      position: fixed;
      bottom: 0;
      right: 0;
      z-index: 1;
  } */
</style>


<div class="topbar">
<CBrow compressed="{scrollY>40 || outerWidth <= 768}" bgcolor="var(--palette-grad2)" smallSidebar="true" fullCover="{navExpand}">
    <div slot="left">
    <div class="heading small" style="width: 150px">EMBEDDED SOFTWARE DEVELOPER</div>
    <div class="handwriting small">Micael Axestål</div>
    <div class="toplogo {firstExpand ? "" : "hide"} {navExpand ? "" : "hidden"}">
        <img src="/Logo_bg_sm.png" alt="Copperbyte Solutions logo" style="margin-bottom: 15px;" width="170" height="66">
    </div>
    </div>
    <div slot="right" style="text-align: center;width: 100%; height: 100%">
    <span class="navTrigger {navExpand ? 'active': ''}" on:click={navTrig}>
        <i></i>
        <i></i>
        <i></i>
    </span>
    <div id="mainListDiv" class="main_list {navExpand ? 'show_list': ''}">
        <ul class="navlinks">
            <li><a on:click={() => scrollToElement("",              "", true)}>Home</a></li>
            <li><a on:click={() => scrollToElement("#aboutme",     -67, false)}>Who I Am</a></li>
            <li><a on:click={() => scrollToElement("#whatido",     -67, false)}>What I Do</a></li>
            <li><a on:click={() => scrollToElement("#whativedone", -67, false)}>What I've Done</a></li>
            <li><a on:click={() => scrollToElement("#contact",     -67, false)}>Contact</a></li>
        </ul>
    </div>
</CBrow>
</div>

<!-- <div class="floater">
    Up
</div> -->
